import { render, staticRenderFns } from "./PaymentShipper.vue?vue&type=template&id=2fa1ea8c&scoped=true"
import script from "./PaymentShipper.vue?vue&type=script&lang=js"
export * from "./PaymentShipper.vue?vue&type=script&lang=js"
import style0 from "./PaymentShipper.vue?vue&type=style&index=0&id=2fa1ea8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa1ea8c",
  null
  
)

export default component.exports